/**
 * Después de un despliegue, una pestaña abierta (o un `index.html` que el
 * navegador guardó) pide pedazos de código de la versión anterior, que ya no
 * existen, y el import dinámico truena (Hugo, 2026-10-28). Recargar una vez
 * trae la versión nueva; la marca evita un ciclo si recargar no basta.
 */
const RELOAD_KEY = 'oranje-reload-after-deploy'
const RELOAD_WINDOW_MS = 10_000

/** Chrome, Safari y Firefox lo dicen distinto; Vite, al precargar CSS. */
const STALE_CHUNK =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return STALE_CHUNK.test(message)
}

/**
 * Recarga la página una sola vez. `false` si ya se recargó hace menos de
 * 10 s, o si no hay dónde guardar la marca: sin ella no se puede evitar el
 * ciclo, así que no se recarga sola.
 */
export function reloadOnceForNewVersion(now: number = Date.now()): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) ?? 0)
    if (now - last < RELOAD_WINDOW_MS) return false
    window.sessionStorage.setItem(RELOAD_KEY, String(now))
  } catch {
    return false
  }
  window.location.reload()
  return true
}
